<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-form @submit.prevent="submitForm">
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="maestroTarjeta.nombre"
              label="Tarjeta"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="maestroTarjeta.porcentaje_comision"
              label="Porcentaje Comisión"
              type="number"
              step="0.01"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ maestroTarjeta.id ? 'Actualizar' : 'Crear' }} Tarjeta
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { useMaestroTarjetasStore } from '@/stores/maestroTarjetasStore'
import { getToken } from '@/utils/tokenStorage'
import { userIsRecepcion } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'

const props = defineProps({
  id: {
    type: Number,
    default: null
  }
})

const maestroTarjetasStore = useMaestroTarjetasStore()
const userIsRecepcionValue = userIsRecepcion()
const loading = ref(false)
const emit = defineEmits(['saved'])

const maestroTarjeta = reactive({
  id: null,
  nombre: '',
  porcentaje_comision: null
})

const isNewRecord = computed(() => !maestroTarjeta.id)

onMounted(async () => {
  if (props.id) {
    loading.value = true
    try {
      const maestroTarjetaData = await maestroTarjetasStore.getMaestroTarjeta(
        props.id
      )
      Object.assign(maestroTarjeta, maestroTarjetaData)
      maestroTarjeta.porcentaje_comision = parseFloat(
        maestroTarjeta.porcentaje_comision
      ).toFixed(2)
    } catch (error) {
      console.error('Error al cargar la tarjeta:', error)
    } finally {
      loading.value = false
    }
  }
})

const submitForm = async () => {
  loading.value = true
  try {
    const token = getToken()
    if (maestroTarjeta.id) {
      await maestroTarjetasStore.updateMaestroTarjeta(maestroTarjeta, token)
    } else {
      await maestroTarjetasStore.createMaestroTarjeta(
        { ...maestroTarjeta },
        token
      )
    }
    emit('saved')
  } catch (error) {
    console.error('Error al guardar la tarjeta:', error)
  } finally {
    loading.value = false
  }
}

defineExpose({
  maestroTarjeta,
  loading,
  isNewRecord,
  submitForm,
  userIsRecepcion: () => userIsRecepcionValue
})
</script>
